import { __awaiter } from "tslib";
import Vue from 'vue';
import sidebar from '@/components/pages/mainPage/sidebar/index.vue';
import dropWrapper from '@/components/global/drop-wrapper/index.vue';
import positions from '@/components/pages/mainPage/tables/positions.vue';
import bids from '@/components/pages/mainPage/tables/bids.vue';
import draggable from 'vuedraggable';
import BREAKPOINTS from '@/constants/breakpoints';
import { getElementStylePropertyNum } from '@/utils/dom-helpers';
import { mapGetters } from 'vuex';
import translation from '@/assets/rawData/i18n/mainPage.json';
import applyPageI18NMessages from '@/vue-utils/i18n';
import { BigNumber } from 'bignumber.js';
import hints from '@/components/pages/mainPage/tables/hints/hints.vue';
import services from '@/services';
import _ from 'lodash';
import { getPassportUrl } from '@/utils/other';
import { i18n } from '@/main';
var Tables;
(function (Tables) {
    Tables["positions"] = "positions";
    Tables["bids"] = "bids";
    Tables["resizer"] = "resizer";
})(Tables || (Tables = {}));
const toDragList = [
    {
        name: Tables.positions,
        id: 0
    },
    {
        name: Tables.resizer,
        id: 1
    },
    {
        name: Tables.bids,
        id: 2
    }
];
const changeHintsDataDebounce = _.debounce(function (context) {
    return __awaiter(this, void 0, void 0, function* () {
        yield services.v2.trade.changeHintsState({
            isVisible: context.visibilityHints,
            isCollapsed: context.collapseHints !== 0
        });
    });
}, 500);
function setPositionsTableSizePreset(size = null, position = null) {
    const body = {
        size: 0,
        position: 0
    };
    const takenPreset = JSON.parse(localStorage.getItem('mainPage-positionsPreset') || 'null');
    const doSet = () => { localStorage.setItem('mainPage-positionsPreset', JSON.stringify(body)); };
    if (takenPreset) {
        if (size !== null || position !== null) {
            if (size) {
                body.size = size;
                body.position = takenPreset.position;
            }
            if (position) {
                body.position = position;
                body.size = takenPreset.size;
            }
            doSet();
        }
        else {
            body.size = takenPreset.size;
            body.position = takenPreset.position;
            if (body.position > 0) {
                toDragList.reverse();
            }
        }
    }
    else {
        doSet();
    }
}
function setTablesHeights(positionsHeight, baseHeight, isInit = false) {
    const containerHeight = baseHeight > 850 ? 850 : baseHeight;
    const positionsTableSizePreset = JSON.parse(localStorage.getItem('mainPage-positionsPreset') || 'null');
    const setHeight = (pos) => {
        var _a;
        const tables = document.querySelectorAll('.mainPage-cards .card');
        let positionsIndex = 0;
        if (tables) {
            if (((_a = tables[0]) === null || _a === void 0 ? void 0 : _a.getAttribute('id')) === 'bids')
                positionsIndex = 1;
        }
        const positionsEl = document.getElementById('positions');
        const bidsEl = document.getElementById('bids');
        const doSetHeight = (el, value, parentID) => {
            var _a;
            el.style.setProperty('--baseHeight', value + 'px');
            // eslint-disable-next-line no-unused-expressions
            (_a = document.getElementById(parentID)) === null || _a === void 0 ? void 0 : _a.style.setProperty('--ghostBaseHeight', value + 'px');
        };
        if (!positionsIndex) {
            if (positionsEl)
                doSetHeight(positionsEl, pos, 'drop-wrapper-mainPagePositions');
            if (bidsEl)
                doSetHeight(bidsEl, containerHeight - pos, 'drop-wrapper-mainPageBids');
        }
        else {
            if (bidsEl)
                doSetHeight(bidsEl, pos, 'drop-wrapper-mainPageBids');
            if (positionsEl)
                doSetHeight(positionsEl, containerHeight - pos, 'drop-wrapper-mainPagePositions');
        }
        setPositionsTableSizePreset(pos, null);
    };
    if (positionsHeight > 0) {
        if (positionsHeight < 257) {
            setHeight(257);
        }
        else if (positionsHeight > containerHeight - 257) {
            setHeight(containerHeight - 257);
        }
        else
            setHeight(positionsHeight);
    }
    else {
        if (isInit) {
            if (positionsTableSizePreset) {
                setHeight(+positionsTableSizePreset.size > 0 ? +positionsTableSizePreset.size : containerHeight / 2);
            }
            else {
                setHeight(containerHeight / 2);
            }
        }
        else
            setHeight(containerHeight / 2);
    }
}
export default Vue.extend({
    data: () => ({
        USDPriceSocket: null,
        dragEnabled: true,
        isDragging: false,
        tablesIsResizing: false,
        isFullyInited: false,
        containerBase: +BREAKPOINTS.MIN_CONTAINER_HEIGHT_DESKTOP,
        toDragList,
        scrollPosition: 0,
        scrollingDown: false,
        visibilityHints: false,
        collapseHints: null,
        apiKeyHint: {
            title: i18n.t('hints.createApi'),
            description: i18n.t('hints.createFirstApi'),
            buttonText: i18n.t('hints.create'),
            iconName: 'hint-key',
            link: {
                name: 'apiKeys',
                query: {
                    'create-mode': 'true'
                }
            },
            linkOut: false,
            visible: true
        },
        depositedHint: {
            title: i18n.t('hints.refillAccount'),
            description: i18n.t('hints.fundYourAccount'),
            buttonText: i18n.t('hints.refill'),
            iconName: 'hint-account',
            link: {
                name: 'transfersPage'
            },
            linkOut: false,
            visible: true
        },
        kycPassedHint: {
            title: i18n.t('hints.passKYC'),
            description: i18n.t('hints.completeKYC'),
            buttonText: i18n.t('hints.pass'),
            iconName: 'hint-kyc',
            link: getPassportUrl('/id/?verification-show=true', { withAcceptor: true }),
            linkOut: true,
            visible: true
        },
        twoFactorHint: {
            title: i18n.t('hints.connect2FA'),
            description: i18n.t('hints.addSecondSecurity'),
            buttonText: i18n.t('hints.connect'),
            iconName: 'hint-2fa',
            link: getPassportUrl('/id/?two-factor-show=true', { withAcceptor: true }),
            linkOut: true,
            visible: true
        }
    }),
    computed: Object.assign(Object.assign(Object.assign({}, mapGetters('leverages', ['getLeveragesBody'])), mapGetters('mainPageModules', ['getSocketsLoading'])), { hintsData() {
            const cards = [this.kycPassedHint, this.apiKeyHint, this.depositedHint, this.twoFactorHint].filter((card) => card.visible);
            return cards;
        } }),
    methods: {
        transferSelectOpenHandler(value) {
            // if (value) return this.deactivateAltScroll()
            // this.activateAltScroll()
        },
        initUSDPriceSocket() {
            this.USDPriceSocket = new WebSocket('wss://fstream.binance.com/ws/!assetIndex@arr');
            this.USDPriceSocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                const result = data.reduce((acc, coinData) => {
                    const price = coinData.i;
                    const symbol = coinData.s.slice(0, -3);
                    return Object.assign(Object.assign({}, acc), { [symbol]: BigNumber(price) });
                }, {});
                this.$store.commit('mainPageModules/setUSDRates', result);
            };
        },
        closeUSDSocketConnection() {
            this.USDPriceSocket.onclose = null;
            this.USDPriceSocket.close();
            this.USDPriceSocket = null;
        },
        setContainerBase(isInit) {
            const containerOffset = getElementStylePropertyNum('#mainWrapper', 'margin-top') + getElementStylePropertyNum('#mainWrapper', 'padding-top');
            const resizerHeight = getElementStylePropertyNum('#tablesResizer', 'height');
            const result = (window.innerHeight - containerOffset - resizerHeight - 54);
            let current = result > +BREAKPOINTS.MIN_CONTAINER_HEIGHT_DESKTOP ? result : +BREAKPOINTS.MIN_CONTAINER_HEIGHT_DESKTOP;
            const sidebar = document.querySelector('.mainPageSidebar');
            const sidebarHeight = sidebar ? sidebar.clientHeight : 0;
            if (sidebarHeight) {
                if (current < sidebarHeight - resizerHeight)
                    current = sidebarHeight - resizerHeight;
            }
            this.containerBase = current > 854 ? 854 : current;
            this.$store.commit('dropData/setMainPageContainerHeight', current);
            setTablesHeights(0, current, isInit);
        },
        handleDragStart() {
            document.body.classList.add('grabbing');
            this.isDragging = true;
        },
        handleDragEnd() {
            const vm = this;
            for (const item in vm.toDragList) {
                if (vm.toDragList[item].id === 1 && item !== '1') {
                    vm.toDragList.splice(1, 0, vm.toDragList.splice(+item, 1)[0]);
                }
            }
            setPositionsTableSizePreset(null, vm.toDragList.findIndex((item) => item.name === Tables.positions));
            document.body.classList.remove('grabbing');
            vm.isDragging = false;
            setTimeout(() => {
                vm.initResizer();
                setTablesHeights(vm.$store.getters['dropData/getGhostHeight'], vm.containerBase);
            }, 100);
        },
        initResizer() {
            const vm = this;
            const resizerEl = document.getElementById('tablesResizer');
            const tables = document.querySelectorAll('.mainPage-cards .card');
            let positionsIndex = 0;
            if (tables) {
                if (tables[0].getAttribute('id') === 'bids')
                    positionsIndex = 1;
            }
            function handleMove(event) {
                if (resizerEl) {
                    const positionsEl = document.getElementById(positionsIndex ? 'bids' : 'positions');
                    let positionsHeight = vm.$store.getters['dropData/getGhostHeights'].mainPagePositions;
                    if (positionsEl)
                        positionsHeight = positionsEl.clientHeight;
                    const newVal = positionsHeight + event.pageY - resizerEl.getBoundingClientRect().top;
                    setTablesHeights(newVal, vm.containerBase, false);
                    vm.$store.commit('dropData/setGhostHeight', { name: 'mainPagePositions', value: newVal });
                    vm.$store.commit('dropData/setGhostHeight', { name: 'mainPageBids', value: vm.containerBase - newVal });
                }
            }
            function handleMouseUp() {
                document.removeEventListener('mousemove', handleMove);
                document.removeEventListener('mouseup', handleMouseUp);
                vm.tablesIsResizing = false;
                document.body.classList.remove('grabbing');
            }
            if (resizerEl) {
                resizerEl.addEventListener('mousedown', (event) => {
                    if (!(vm.isDropped('mainPagePositions') || vm.isDropped('mainPageBids'))) {
                        vm.tablesIsResizing = true;
                        document.body.classList.add('grabbing');
                        document.addEventListener('mousemove', handleMove, false);
                        document.addEventListener('mouseup', handleMouseUp, false);
                    }
                    else {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }, false);
            }
        },
        // handleScroll (event: any) {
        //   event.preventDefault()
        //   this.scrollingDown = event.deltaY < 0
        //   this.scrollPosition += 1
        // },
        // altScrollHandler () {
        //   !this.mah(769) && !this.maw(1200) ? this.activateAltScroll() : this.deactivateAltScroll()
        // },
        // activateAltScroll () {
        //   if (this.visibilityHints) return
        //   window.addEventListener('wheel', this.handleScroll, { passive: false })
        //   this.scrollPosition = -1
        // },
        // deactivateAltScroll () {
        //   window.removeEventListener('wheel', this.handleScroll)
        //   this.scrollPosition = -1
        // },
        getHints() {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield services.v2.trade.getHintsData();
                const data = response.data.payload;
                this.collapseHints = data.isCollapsed ? null : 0;
                this.visibilityHints = data.isVisible;
                this.apiKeyHint.visible = !data.widgets.apiKeyCreated;
                this.depositedHint.visible = !data.widgets.deposited;
                this.kycPassedHint.visible = !data.widgets.kycPassed;
                this.twoFactorHint.visible = !data.widgets.twoFactorApplied;
                const visibleHint = this.apiKeyHint.visible | this.depositedHint.visible | this.kycPassedHint.visible | this.twoFactorHint.visible;
                if (!visibleHint) {
                    this.visibilityHints = false;
                }
                // if (this.visibilityHints) this.deactivateAltScroll()
            });
        },
        changeVisibilityHints() {
            return __awaiter(this, void 0, void 0, function* () {
                this.visibilityHints = !this.visibilityHints;
                yield services.v2.trade.changeHintsState({
                    isVisible: this.visibilityHints,
                    isCollapsed: this.collapseHints !== 0
                });
                this.$store.dispatch('alertsBus/openAlert', {
                    title: this.$t('hints.success'),
                    type: 'info',
                    autoDelete: true,
                    content: this.$t('hints.tooltips'),
                    action: {
                        text: this.$t('hints.cancel'),
                        callback: () => {
                            this.visibilityHints = !this.visibilityHints;
                            services.v2.trade.changeHintsState({
                                isVisible: this.visibilityHints,
                                isCollapsed: this.collapseHints !== 0
                            });
                        }
                    }
                });
            });
        },
        changeCollapseHints() {
            return __awaiter(this, void 0, void 0, function* () {
                this.collapseHints = this.collapseHints === null ? 0 : null;
                changeHintsDataDebounce(this);
            });
        }
    },
    mounted() {
        const vm = this;
        vm.setContainerBase(true);
        vm.initResizer();
        vm.isFullyInited = true;
        // this.altScrollHandler()
        window.addEventListener('resize', () => {
            vm.setContainerBase(true);
            // this.altScrollHandler()
        });
        this.getHints();
    },
    beforeDestroy() {
        // this.deactivateAltScroll()
        this.closeUSDSocketConnection();
    },
    created() {
        const vm = this;
        this.initUSDPriceSocket();
        applyPageI18NMessages(this, 'mainPage', translation);
        window.addEventListener('resize', () => {
            vm.winHeight = window.innerHeight;
        });
        if (!vm.getSocketsLoading) {
            vm.$store.dispatch('mainPageModules/loadSockets');
        }
        setPositionsTableSizePreset(null, null);
    },
    components: {
        dropWrapper,
        sidebar,
        positions,
        bids,
        draggable,
        hints
    }
});
